module.exports = __webpack_public_path__ + "static/media/35.85c78a5a.jpg";